import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import clienteAuthService from '../api/authService';

export default function ClienteLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await clienteAuthService.login(form.email, form.password);
      navigate('/area-riservata');
    } catch (err) {
      setError(err.response?.data?.message || 'Credenziali non valide');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFFEFA] flex items-center justify-center px-4">
      <div className="w-full max-w-md mang-card p-8">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Area Riservata</h1>
        <p className="text-gray-500 text-sm mb-6">Accedi per vedere ordini e storico acquisti</p>
        {import.meta.env.DEV && (
          <div className="bg-amber-50 border border-amber-200 text-amber-900 text-xs rounded-lg p-3 mb-4">
            <strong>Demo locale:</strong> cliente@mangitalia.it / Cliente2025!
          </div>
        )}
        {error && <div className="bg-red-50 text-red-700 text-sm p-3 rounded-lg mb-4">{error}</div>}
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input type="email" required className="w-full border rounded-xl px-4 py-2.5" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Password</label>
            <input type="password" required className="w-full border rounded-xl px-4 py-2.5" value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-[#c78244] text-white py-3 rounded-xl font-semibold hover:opacity-90 disabled:opacity-50">
            {loading ? 'Accesso…' : 'Accedi'}
          </button>
        </form>
        <p className="text-center text-sm mt-3">
          <Link to="/area-riservata/forgot-password" className="text-[#c78244] underline">Password dimenticata?</Link>
        </p>
        <p className="text-center text-sm text-gray-500 mt-4">
          Non hai un account? <Link to="/area-riservata/registrati" className="text-[#c78244] underline">Registrati</Link>
        </p>
        <p className="text-center text-sm mt-2"><Link to="/catalogo" className="text-gray-400">← Torna al catalogo</Link></p>
      </div>
    </div>
  );
}
